import { Button, ButtonRow, Heading } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import { LoginMfaHelpFooter } from '../../elements/LoginMfaHelpFooter';
import { MfaAppsInfo } from './MfaAppsInfo';

interface IDownloadMfaAppProps {
    activationToken?: string;
    goBack: () => void;
    goToNextStep: () => void;
}

export function DownloadMfaApp(props: IDownloadMfaAppProps) {
    const translate = getSelectedLanguage();

    return (
        <>
            <Heading>{props.activationToken ? 'Account activeren' : 'Tweestapsverificatie instellen'}</Heading>
            <MfaAppsInfo />
            <ButtonRow>
                <Button
                    color="secondary"
                    onClick={() => props.goToNextStep()}
                    width="full"
                >
                    {translate.common.next}
                </Button>
                <Button
                    color="secondary"
                    onClick={() => props.goBack()}
                    variant="outline"
                    width="full"
                >
                    {translate.common.previous}
                </Button>
            </ButtonRow>
            <LoginMfaHelpFooter instructionsVideo="app" />
        </>
    );
}
